import { atom } from 'recoil';
import { DateFilterState, DefaultDateFilter, useDateFilter } from './dateFilter';
import { HasAdjustments, InvoiceStatus } from 'enums';

type Sort = {
    text: string,
    compare: (a: any, b: any) => number,
    order: 'asc' | 'desc',
};

export const InvoiceSortOptions: Sort[] = [
    {
        text: 'Sort By',
        compare: () => 0,
        order: 'asc'
    },
    {
        text: 'Invoice Date: Ascending',
        compare: (a: any, b: any) => a.paymentDate - b.paymentDate,
        order: 'asc'
    },
    {
        text: 'Invoice Date: Descending',
        compare: (a: any, b: any) => b.paymentDate - a.paymentDate,
        order: 'desc'
    },
    {
        text: 'Invoice Amt: High to Low',
        compare: (a: any, b: any) => b.userVoucherDecimal - a.userVoucherDecimal,
        order: 'desc'
    },
    {
        text: 'Invoice Amt: Low to High',
        compare: (a: any, b: any) => a.userVoucherDecimal - b.userVoucherDecimal,
        order: 'asc'
    },
    {
        text: 'Paid Amt: High to Low',
        compare: (a: any, b: any) => b.invoicePaidAmount - a.invoicePaidAmount,
        order: 'desc'
    },
    {
        text: 'Paid Amt: Low to High',
        compare: (a: any, b: any) => a.invoicePaidAmount - b.invoicePaidAmount,
        order: 'asc'
    },
    {
        text: 'Adjustment Amt: High to Low',
        compare: (a: any, b: any) => (b.dotPriceAdjustment + b.dotQuantityAdjustment) - (a.dotPriceAdjustment + a.dotQuantityAdjustment),
        order: 'desc'
    },
    {
        text: 'Adjustment Amt: Low to High',
        compare: (a: any, b: any) => (a.dotPriceAdjustment + a.dotQuantityAdjustment) - (b.dotPriceAdjustment + b.dotQuantityAdjustment),
        order: 'asc'
    }
];

type InvoiceFilterState = { 
    invoicesStartAmount?: number, 
    invoicesEndAmount?: number, 
    invoiceId?: string,
    status?: InvoiceStatus,
    poNumber?: string,
    checkNumber?: string,
    hasAdjustments?: HasAdjustments,
    adjustmentStartAmount?: number,
    adjustmentEndAmount?: number,
    searchTerm?: string,
    searchKeys: string[],
    sort: Sort
} & DateFilterState;

export const invoiceFilter = atom<InvoiceFilterState>({
    key: 'invoiceFilter',
    default: {
        ...DefaultDateFilter,
        searchKeys: ['userVoucherDecimal' , 'invoiceId', 'invoicePaidAmount', 'discountPaymentAmount', 'invoicePaidAmount'],
        sort: InvoiceSortOptions[2]
    }
});

export const useInvoiceFilter = () => {
    const { setField, ...state } = useDateFilter(invoiceFilter);

    return {
        ...state,
        setInvoicesStartAmount: (value?: number) => setField('invoicesStartAmount', value),
        setInvoicesEndAmount: (value?: number) => setField('invoicesEndAmount', value),
        setStatus: (value?: InvoiceStatus) => setField('status', value),
        setInvoiceId: (value?: string) => setField('invoiceId', value),
        setCheckNumber: (value?: string) => setField('checkNumber', value),
        setPoNumber: (value?: string) => setField('poNumber', value),
        setHasAdjustments: (value?: HasAdjustments) => setField('hasAdjustments', value),
        setAdjustmentStartAmount: (value?: number) => setField('adjustmentStartAmount', value),
        setAdjustmentEndAmount: (value?: number) => setField('adjustmentEndAmount', value),
        setSearchTerm: (value?: string) => setField('searchTerm', value),
        setSort: (value: Sort) => setField('sort', value)
    };
};
